
<div id="wrap-viz-chart"> <div [chart]="chartObject" id="month-new-patient-visits-graph"></div> </div>
<app-chart-legend
        [metricType]="metricType.NewPatientVisits"
        [legends]="npvLegends"
        [hasBenchmarks]="hasBenchmarks"
        [benchmarksToExclude]="benchmarkToExclude">
</app-chart-legend>
